import React from "react";
import { Button, NumberInput, SelectInput, TextInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import { ScholarshipCategoryChoices, SchorashipTypeChoices } from "utils/choices";
import dataProvider from "server/dataProvider";
import { scholarshipRequests } from "api/scholarshipApi";

const EditAmountDialog = ({ type, category, amount, fetchApprovedApplications }) => {
  const notify = useNotify();

  const handleConfirm = async values => {
    await dataProvider.customRequest(scholarshipRequests.updateScholarshipAmount(), values, "PUT");
    notify("Успешно редактиране", { type: "success" });
    fetchApprovedApplications();
  };
  return (
    <FormModal
      defaultValues={{ type, category, amount }}
      titleContent="Редактирай"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Редактирай"
          color="primary"
          variant="contained"
          startIcon={<EditIcon />}
        />
      }
    >
      <SelectInput
        choices={SchorashipTypeChoices}
        source="type"
        label="Тип стипендия"
        optionText="name"
        fullWidth
        isRequired
        emptyText={false}
      />
      <SelectInput
        choices={ScholarshipCategoryChoices}
        source="category"
        label="Категория стипендия"
        optionText="name"
        fullWidth
        emptyText={false}
      />
      <NumberInput
        source="amount"
        isRequired
        label="Сума"
      />
      <TextInput
        source="description"
        label="Описание"
      />
    </FormModal>
  );
};

export default EditAmountDialog;
